import {
    POS_GET_INVENTORY,
    POS_GET_INVENTORY_SUCCESS,
    POS_GET_INVENTORY_ERROR
} from './actions';

const INIT_STATE = {
    posInventoryList: [],
    loading: false,
    error: '',
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case POS_GET_INVENTORY:
            return { ...state, loading: true, error: '' };
        case POS_GET_INVENTORY_SUCCESS:
            return { ...state, loading: false, posInventoryList: action.payload, error: '' };
        case POS_GET_INVENTORY_ERROR:
            return { ...state, loading: false, error: action.payload };
        default:
            return { ...state };
    }
};